var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3G(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3334 5.5V3.83333H15.6667V2.16667C15.6667 1.25 14.9167 0.5 14.0001 0.5H2.33341C1.41675 0.5 0.666748 1.25 0.666748 2.16667V13.8333C0.666748 14.75 1.41675 15.5 2.33341 15.5H14.0001C14.9167 15.5 15.6667 14.75 15.6667 13.8333V12.1667H17.3334V10.5H15.6667V8.83333H17.3334V7.16667H15.6667V5.5H17.3334ZM14.0001 13.8333H2.33341V2.16667H14.0001V13.8333ZM4.00008 8.83333H8.16675V12.1667H4.00008V8.83333ZM9.00008 3.83333H12.3334V6.33333H9.00008V3.83333ZM4.00008 3.83333H8.16675V8H4.00008V3.83333ZM9.00008 7.16667H12.3334V12.1667H9.00008V7.16667Z",
    fill: "#8B8B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3G);
export default __webpack_public_path__ + "static/media/icon3_g.d81569ad047ea578afd8ebd6e3f280d1.svg";
export { ForwardRef as ReactComponent };